import { GetMasterPointResponse } from "services/interface";
import styled from "@emotion/styled";
import { Col, Row, message } from "antd";
import { Dispatch, FC, SetStateAction } from "react";
import TableUserSystem from "./TableSettingPointSystem";
import { useQueryClient } from "@tanstack/react-query";
import { useDeleteMasterPoint } from "hooks/useMasterData";

interface SettingPointListProps {
  data: GetMasterPointResponse | undefined;
  refetch: () => void;
  limit: number;
  offset: number;
  setLimit: Dispatch<SetStateAction<number>>;
  setOffset: Dispatch<SetStateAction<number>>;
}

const SettingPointList: FC<SettingPointListProps> = ({
  data,
  refetch,
  limit,
  offset,
  setLimit,
  setOffset,
}) => {
  const { mutate: DeleteDelete, isPending: deleteLoading } =
    useDeleteMasterPoint();

  const queryClient = useQueryClient();

  const onDeleteConfigs = (id: string) => {
    DeleteDelete(
      {
        id: id,
      },
      {
        onSuccess: async (res) => {
          if (!res.error_message) {
            await queryClient.refetchQueries({
              queryKey: ["get_master_point"],
              type: "active",
            });
            message.success("ลบสำเร็จ");
            refetch();
          } else {
            message.error(`ลบไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`ลบไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  };

  return (
    <WrapperAll>
      <Row
        gutter={[16, 16]}
        style={{ backgroundColor: "#EFEFEF", overflow: "auto" }}
      >
        <Col span={24}>
          <CardWrapperTable>
            <TableUserSystem
              data={data?.data.data}
              onDeleteConfigs={onDeleteConfigs}
              limit={limit}
              offset={offset}
              setLimit={setLimit}
              setOffset={setOffset}
              total={data?.data.total_record || "0"}
            />
          </CardWrapperTable>
        </Col>
      </Row>
    </WrapperAll>
  );
};

export default SettingPointList;
const WrapperAll = styled.div`
  background-color: #efefef;
`;

const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;
